import { gql } from '@apollo/client';

import { AuthTokensFragment } from '../fragments';

export const RefreshTokenMutation = gql`
    mutation RefreshToken($refreshToken: String!) {
        refreshToken(refreshToken: $refreshToken) {
            ...AuthTokens
        }
    }
    ${AuthTokensFragment}
`;
